import React from 'react';
import { ExternalLink } from 'lucide-react';

const PublishedBy = () => (
  <section className="py-12 bg-white border-t border-[#F5F3F0]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <p className="text-xs tracking-widest text-[#8B7D6B] mb-4">PUBLISHED BY</p>
        <a
          href="https://www.independent.com.mt/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 group"
          data-testid="published-by-link"
        >
          <span
            className="text-2xl text-[#2C2C2C] group-hover:text-[#DE92A9] transition-colors"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            The Malta Independent
          </span>
          <ExternalLink size={16} className="text-[#DE92A9] opacity-0 group-hover:opacity-100 transition-opacity" />
        </a>
        <p className="text-[#8B7D6B] text-sm mt-2">Standard Publications Ltd</p>
      </div>
    </div>
  </section>
);

export default PublishedBy;
